export const GET_REPORT_INITIAL_CALL =
  "/report1/getreportdetailsbasedoneventid";
export const GET_REPORT_FINAL_SUBMIT_CALL =
  "/report1/getreportdetailsbasedonparameters";
// export const GET_CAMERA_LIST_CALL = "/camera/get_cameraList";
export const GET_CAMERA_LIST_CALL = "/report1/getcameralist";
export const GET_CAMERA_LIST_CALL1 = "/cameraEvents/getcameralisteventsetup";
export const GET_EVENT_LIST_CALL = "/report1/geteventlist";
export const GET_EVENT_LIST_CALL1 = "/cameraEvents/geteventlistforeventsetup";
